'use strict';

function _CryptoActions() {
  this.setCryptoAccountStatus = function (stateData) {
    var accountState = void 0;
    var accountStatusId = stateData.statusId; // null|0|1

    // Additional state for UI when users has created cypto account:
    if (stateData.statusId === true && stateData.crypto_user_actions && !stateData.crypto_user_actions.create_crypto_user) {
      accountStatusId = 2;
    }

    // new state based on tier data:
    if ((stateData.tier_data !== undefined || !!stateData.account_creation_status) && stateData.statusId !== 0) {
      accountStatusId = 3;
    }

    // Make things more readable for us human devs:
    var _cryptoStatusMap = {
      null: 'pending',
      false: 'ineligible',
      true: 'eligible',
      2: 'active',
      3: 'tiered'
    };
    accountState = _cryptoStatusMap[accountStatusId];

    return {
      type: SET_CRYPTOACCOUNT_STATE,
      payload: {
        accountStatus: accountState
      }
    };
  };
}